module.exports = __webpack_public_path__ + "img/udpu_logo.9b9b5cd5.jpg";